import { createGlobalStyle } from 'styled-components';

import { withDecoratedScroll } from './common';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    background: #000008;
    overflow: hidden;
    font-family: 'Rajdhani', sans-serif;
    -webkit-tap-highlight-color: transparent;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    color: rgba(255, 255, 255, 0.6);
    overscroll-behavior: none;
    color-scheme: 'dark';
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Adam', 'Rajdhani', sans-serif;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    margin: 0;
  }

  img {
    display: block;
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  input,
  textarea,
  select {
    font-family: inherit;
  }

  sup {
    position: static;
    vertical-align: super;
  }

  [data-mobile-only] {
    @media (min-width: 601px) {
      display: none !important;
    }
  }

  [data-desktop-only] {
    @media (max-width: 600px) {
      display: none !important;
    }
  }

  [hidden] {
    display: none !important;
  }

  [data-no-pointer-event='true'] {
    pointer-events: none !important;
  }

  .color-green {
    color: #10b981;
  }

  .color-red {
    color: #ef4444;
  }

  :root {
    --ui-control-height: 44px;
    --red: #ef4444;
    --green: #10b981;
    --yellow: #eab308;
    --blue: #3b82f6;

    --info: #3b82f6;
    --success: #10b981;
    --warning: #eab308;
    --error: #ef4444;

    --toastify-color-info: #3b82f6;
    --toastify-color-success: #10b981;
    --toastify-color-warning: #eab308;
    --toastify-color-error: #ef4444;
  }

    // disable Ripple Effect
  // INFO: https://github.com/mui/material-ui/issues/240
  .MuiTouchRipple-root {
    display: none;
  }

  .MuiSkeleton-root {
    display: inline-block  !important;
    background: rgba(255, 255, 255, 0.15) !important;
  }

  .MuiTooltip-tooltip {
    max-width: 400px !important;
    background: #3b3b44 !important;
    font-size: 15px !important;
    line-height: 1.5 !important;

    @media (max-width: 600px) {
      font-size: 13px !important;
    }
  }

  // rainbowKit modal
  [data-rk][role="dialog"] * {
    ${withDecoratedScroll}
  }
`;
